/**
 * @file Observe dark mode
 */

type observeDarkModeHandler = (darkMode: boolean) => void
function observeDarkMode(handler: observeDarkModeHandler): (() => void) | null {
  if (!handler || typeof window.matchMedia !== 'function') return null

  function listener(ev: MediaQueryListEvent): void {
    if (ev) {
      const darkMode = ev.matches
      handler(darkMode)
    }
  }

  handler(window.matchMedia('(prefers-color-scheme: dark)').matches)
  const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  darkModeMediaQuery.addListener(listener)
  // mql.addEventListener not supported on Safari and IE
  const unobserveDarkMode = (): void => darkModeMediaQuery.removeListener(listener)
  return unobserveDarkMode
}
export { observeDarkMode }
